export const RISK = {
  RR: "0", // RAIN RADAR
  RT: "1", // RAIN TOTAL
  FL: "2", // FLOOD
  VWS: "3", // VIRTUAL WATER SURFACE
  GR: "4", // GUERRILLA RAINFALL
};
